{
  "advanced_feature_modal": {
    "title": "Advanced feature",
    "body": "{feature} is an advanced feature that can only be set up in the SparkLayer dashboard."
  }
}
